import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { setToggleTableView } from "../../../store/slices/jobPricingDetailsSlice";
import "./ReportTableToggleButton.scss";

export const ReportTableToggleButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isToggleTableView } = useSelector(
    (state: RootState) => state.jobPricingDetails
  );
  return (
    <div className="table-toggle-container">
      <Button
        variant="text"
        color="inherit"
        endIcon={
          isToggleTableView ? (
            <ExpandLessIcon sx={{ fontSize: "24px !important" }} />
          ) : (
            <ExpandMoreIcon sx={{ fontSize: "24px !important" }} />
          )
        }
        onClick={(e) => dispatch(setToggleTableView(!isToggleTableView))}
        sx={{
          ".MuiButton-endIcon": {
            marginTop: "2px"
          }
        }}
      >
        <Typography
          variant="body2"
          sx={{ textTransform: "none", fontWeight: 700 }}
        >
          {isToggleTableView
            ? t("pa.collapseTableView")
            : t("pa.expandTableView")}
        </Typography>
      </Button>
    </div>
  );
};
